import { Reveal } from "@components/ui";
import solutionImage from "@assets/images/Frame-1618869509@2x.png";

const solutions = [
  {
    title: "Design & Consultancy",
    description: "End-to-end gas network planning for new developments",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#122d63",
  },
  {
    title: "Bulk LPG Storage Systems",
    description: "For commercial kitchens, hospitals, and factories",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <rect x="2" y="7" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2M12 11v6M9 14h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#f03813",
  },
  {
    title: "Metering & Billing Integration",
    description: "For owner associations and property managers",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#0a7c3e",
  },
  {
    title: "Energy Optimization Audits",
    description: "Improve efficiency, reduce wastage, and enhance safety",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5 md:w-6 md:h-6">
        <path d="M18 20V10M12 20V4M6 20v-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    iconColor: "#7c3aed",
  },
];

export function CustomSolutionsSection() {
  return (
    <section className="w-full bg-[#f1f1f1] overflow-hidden py-12 md:py-16 lg:py-[100px] px-5 md:px-10 lg:px-[180px]">
      <div className="w-full max-w-[1368px] mx-auto">
        <div className="flex flex-col lg:flex-row items-stretch gap-8 md:gap-10 lg:gap-12">
          {/* Left Content */}
          <Reveal direction="left" className="flex-1 min-w-0">
            <div className="flex flex-col gap-5 md:gap-6 h-full justify-center">
              {/* Pill Badge + Title & Subtitle */}
              <div className="flex flex-col gap-3">
                <span className="inline-block self-start px-4 py-1.5 rounded-full bg-[#122d63]/8 text-[#122d63] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
                  Custom Solutions
                </span>
                <h2 className="text-[22px] md:text-[32px] lg:text-[44px] tracking-[-0.04em] font-semibold text-[#122d63] font-albert-sans leading-[1.1]">
                  Custom Gas Solutions for Specialized Needs
                </h2>
                <p className="text-[13px] md:text-[15px] lg:text-[17px] tracking-[-0.04em] leading-[1.5] text-[#62636c] font-albert-sans">
                  In addition to standard supply services, we also offer tailored
                  gas solutions for developers, property managers, and large
                  infrastructure projects.
                </p>
              </div>

              {/* Solution Items */}
              <div className="flex flex-col gap-2.5">
                {solutions.map((solution, index) => (
                  <Reveal key={solution.title} direction="up" delay={index * 80}>
                    <div className="rounded-[12px] bg-white flex items-center p-3.5 md:p-4 gap-3.5 md:gap-4 group cursor-pointer hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 border border-transparent hover:border-[#e8e9ed]">
                      {/* Tinted Icon Container */}
                      <div
                        className="w-9 h-9 md:w-10 md:h-10 rounded-[10px] flex items-center justify-center shrink-0"
                        style={{ backgroundColor: `${solution.iconColor}14`, color: solution.iconColor }}
                      >
                        {solution.icon}
                      </div>
                      <div className="flex-1 flex flex-col gap-0.5 min-w-0">
                        <h3 className="text-[15px] md:text-[17px] lg:text-[19px] tracking-[-0.04em] font-semibold text-black font-albert-sans leading-[1.2]">
                          {solution.title}
                        </h3>
                        <p className="text-[12px] md:text-[13px] lg:text-[14px] tracking-[-0.04em] text-[#62636c] font-albert-sans leading-[1.4]">
                          {solution.description}
                        </p>
                      </div>
                      {/* Inline SVG Arrow */}
                      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 md:w-5 md:h-5 shrink-0 text-[#62636c] group-hover:text-[#122d63] group-hover:translate-x-1 transition-all duration-300">
                        <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          </Reveal>

          {/* Right Image */}
          <Reveal
            direction="right"
            className="w-full lg:w-[520px] shrink-0"
          >
            <img
              src={solutionImage}
              alt="Custom gas solutions dashboard"
              className="w-full h-[250px] md:h-[400px] lg:h-full rounded-[12px] md:rounded-[20px] object-cover"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
